import { useState } from "react"
import { StarAPIFetchState, WorkflowAnalysis } from "../types/types"
import { addWorkflowAnalysis, getWorkflowAnalysis, updateWorkflowAnalysis } from "../service/workflowAnalysisService"
import { showErrorToast, showSuccessToast } from "../utils/utils"
import useLoadingToast from "./useLoadingToast"

const useWorkflowAnalysis = () => {
  const [workflowAnalysis, setWorkflowAnalysis] = useState<StarAPIFetchState<WorkflowAnalysis[]>>({ status: "idle" })

  const [{
    onShow,
    onHide
  }] = useLoadingToast()

  const onLoadWorkflowAnalysis = async (workflowId: number) => {
    setWorkflowAnalysis({ status: "loading" })
    const response = await getWorkflowAnalysis(workflowId)
    if (response instanceof Error) {
      if (response.cause === "404") {
        setWorkflowAnalysis({ status: "success", data: null })
        return
      }
      setWorkflowAnalysis({ status: "error", error: response })
      return
    }
    setWorkflowAnalysis({ status: "success", data: response })
  }

  const onAddWorkflowAnalysis = async (workflowId: number, comment: string, cuiSuspected: boolean, muiSuspected: boolean) => {
    onShow("Adding workflow overview.")
    setWorkflowAnalysis({ status: "loading" })
    const response = await addWorkflowAnalysis(
        workflowId,
        comment,
        cuiSuspected,
        muiSuspected
      )
    if (response instanceof Error) {
      showErrorToast("Could not add workflow overview.")
    }
    showSuccessToast("Successfully added workflow overview.")
    onLoadWorkflowAnalysis(workflowId)
    onHide()
  }

  const onEditWorkflowAnalysis = async (workflowId: number, analysisId: number, comment: string, cuiSuspected: boolean, muiSuspected: boolean) => {
    onShow("Updating workflow overview.")
    const response = await updateWorkflowAnalysis(
      analysisId,
      comment,
      cuiSuspected,
      muiSuspected
    )
    if (response instanceof Error) {
      showErrorToast("Could not edit workflow overview.")
    }
    showSuccessToast("Workflow overview updated.")
    onLoadWorkflowAnalysis(workflowId)
    onHide()
  }

  return [{
    workflowAnalysis,
    onLoadWorkflowAnalysis,
    onAddWorkflowAnalysis,
    onEditWorkflowAnalysis
  }]
}

export default useWorkflowAnalysis